import { render, staticRenderFns } from "./EstimateIcon.vue?vue&type=template&id=68d50330"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68d50330')) {
      api.createRecord('68d50330', component.options)
    } else {
      api.reload('68d50330', component.options)
    }
    module.hot.accept("./EstimateIcon.vue?vue&type=template&id=68d50330", function () {
      api.rerender('68d50330', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/icon/EstimateIcon.vue"
export default component.exports